import { useDispatch } from 'react-redux';
import requests from '../../../../redux/reducer/requests';

export default function useQuestsCallbacks() {
  const dispatch = useDispatch();

  return {
    getQuests: () => dispatch(requests.thunks.getQuests()),
    collectQuest: (id) => dispatch(requests.thunks.collectQuest(id)),
    completeQuest: (data) => dispatch(requests.thunks.completeQuest(data)),
  };
}
